// extracted by mini-css-extract-plugin
var _1 = "CalendarGridWeek-moduleCalendarGridWeek__kFeeA";
export { _1 as "CalendarGridWeek" }
